
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _91_46_46_46slug_93pPt1p5RGBgMeta } from "/var/www/tiodomin.com/pages/[...slug].vue?macro=true";
import { default as _404020U9BGUT6Meta } from "/var/www/tiodomin.com/pages/404.vue?macro=true";
import { default as LoginG2zX2cWlClMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Login.vue?macro=true";
import { default as MostSoldSOJxJrRY0CMeta } from "/var/www/tiodomin.com/pages/admin/analytics/MostSold.vue?macro=true";
import { default as AccessesN7fcYFKCNHMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/Accesses.vue?macro=true";
import { default as NewUsersrOICgL2gBUMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/NewUsers.vue?macro=true";
import { default as PagesMostVisitedSFCItcfDxGMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/PagesMostVisited.vue?macro=true";
import { default as PerfilPromotorh0kTa7zgroMeta } from "/var/www/tiodomin.com/pages/Admin/analytics/Partials/PerfilPromotor.vue?macro=true";
import { default as ProductsAggregatedCart08G0FSgnsJMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/ProductsAggregatedCart.vue?macro=true";
import { default as ProductsMostSoldIE6dwjtnUFMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/ProductsMostSold.vue?macro=true";
import { default as ProductsMostVisitedgnbjbxTssKMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/ProductsMostVisited.vue?macro=true";
import { default as SalesBehaviourtni7kikIW1Meta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/SalesBehaviour.vue?macro=true";
import { default as _91promotors_93BKesol2kFMMeta } from "/var/www/tiodomin.com/pages/Admin/analytics/promotors/[promotors].vue?macro=true";
import { default as indexAdVNz22uo8Meta } from "/var/www/tiodomin.com/pages/Admin/analytics/promotors/index.vue?macro=true";
import { default as SalesQqgSncrqS2Meta } from "/var/www/tiodomin.com/pages/admin/analytics/Sales.vue?macro=true";
import { default as VisitsBqvrHsNA5jMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Visits.vue?macro=true";
import { default as _91id_93gx3lE7dA4XMeta } from "/var/www/tiodomin.com/pages/admin/banners/[id].vue?macro=true";
import { default as createQxFpATMMsdMeta } from "/var/www/tiodomin.com/pages/admin/banners/create.vue?macro=true";
import { default as indexKV3EFdn8yNMeta } from "/var/www/tiodomin.com/pages/admin/banners/index.vue?macro=true";
import { default as _91id_935rYRsLwjlwMeta } from "/var/www/tiodomin.com/pages/admin/blogs/categories/[id].vue?macro=true";
import { default as createiJqSURftAQMeta } from "/var/www/tiodomin.com/pages/admin/blogs/categories/create.vue?macro=true";
import { default as indexvoyNkTad06Meta } from "/var/www/tiodomin.com/pages/admin/blogs/categories/index.vue?macro=true";
import { default as _91id_93iAbGLbmOBDMeta } from "/var/www/tiodomin.com/pages/admin/blogs/keywords/[id].vue?macro=true";
import { default as createkE298lxZ62Meta } from "/var/www/tiodomin.com/pages/admin/blogs/keywords/create.vue?macro=true";
import { default as indexbt7e7MaSoJMeta } from "/var/www/tiodomin.com/pages/admin/blogs/keywords/index.vue?macro=true";
import { default as _91id_93gAF2CYR8mmMeta } from "/var/www/tiodomin.com/pages/admin/blogs/posts/[id].vue?macro=true";
import { default as createOJKxfxSopYMeta } from "/var/www/tiodomin.com/pages/admin/blogs/posts/create.vue?macro=true";
import { default as indexAOFrt3bXMGMeta } from "/var/www/tiodomin.com/pages/admin/blogs/posts/index.vue?macro=true";
import { default as _91id_93xtvOPG9fFRMeta } from "/var/www/tiodomin.com/pages/admin/brands/[id].vue?macro=true";
import { default as createGaDY3rzJZKMeta } from "/var/www/tiodomin.com/pages/admin/brands/create.vue?macro=true";
import { default as indexr6JOfKYnNfMeta } from "/var/www/tiodomin.com/pages/admin/brands/index.vue?macro=true";
import { default as _91id_93o4A1qtCVCSMeta } from "/var/www/tiodomin.com/pages/admin/categories/[id].vue?macro=true";
import { default as CreateVFJscMFJKAMeta } from "/var/www/tiodomin.com/pages/admin/categories/Create.vue?macro=true";
import { default as indexYdbe1GxdpqMeta } from "/var/www/tiodomin.com/pages/admin/categories/index.vue?macro=true";
import { default as _91id_93njrOj3MHbwMeta } from "/var/www/tiodomin.com/pages/admin/combos/[id].vue?macro=true";
import { default as create8ZdnuHD49UMeta } from "/var/www/tiodomin.com/pages/admin/combos/create.vue?macro=true";
import { default as index46xTRu9zKqMeta } from "/var/www/tiodomin.com/pages/admin/combos/index.vue?macro=true";
import { default as indexpY35mbMUIiMeta } from "/var/www/tiodomin.com/pages/admin/criterias/index.vue?macro=true";
import { default as _91id_93cHhobzAwjTMeta } from "/var/www/tiodomin.com/pages/admin/gift_Cards/[id].vue?macro=true";
import { default as createsHxnayTB3tMeta } from "/var/www/tiodomin.com/pages/admin/gift_Cards/create.vue?macro=true";
import { default as indexMzokhC73ZeMeta } from "/var/www/tiodomin.com/pages/admin/gift_Cards/index.vue?macro=true";
import { default as CreateRN6svJP8GTMeta } from "/var/www/tiodomin.com/pages/admin/invoices/Create.vue?macro=true";
import { default as indexfqGsAIAfNWMeta } from "/var/www/tiodomin.com/pages/admin/invoices/index.vue?macro=true";
import { default as indexvBE1GYyZVvMeta } from "/var/www/tiodomin.com/pages/admin/nomenclator/index.vue?macro=true";
import { default as _91id_93QIFcBX02OrMeta } from "/var/www/tiodomin.com/pages/admin/offers/[id].vue?macro=true";
import { default as Createu4H4Ik0nHCMeta } from "/var/www/tiodomin.com/pages/admin/offers/Create.vue?macro=true";
import { default as indexODBGTy8c2zMeta } from "/var/www/tiodomin.com/pages/admin/offers/index.vue?macro=true";
import { default as showfOQQ6Y5S4kMeta } from "/var/www/tiodomin.com/pages/admin/orders/[order]/show.vue?macro=true";
import { default as indexAvW1GjazVIMeta } from "/var/www/tiodomin.com/pages/admin/orders/index.vue?macro=true";
import { default as _91id_93q9kL2I3cgTMeta } from "/var/www/tiodomin.com/pages/admin/point_of_sales/[id].vue?macro=true";
import { default as createK3kvH2D6SMMeta } from "/var/www/tiodomin.com/pages/admin/point_of_sales/create.vue?macro=true";
import { default as index9YrL0mFXSwMeta } from "/var/www/tiodomin.com/pages/admin/point_of_sales/index.vue?macro=true";
import { default as indexq6eKX6agAEMeta } from "/var/www/tiodomin.com/pages/admin/pointsSystem/index.vue?macro=true";
import { default as indexwFFBTD1HoSMeta } from "/var/www/tiodomin.com/pages/Admin/PrintGiftCards/index.vue?macro=true";
import { default as editIcxCZfa66kMeta } from "/var/www/tiodomin.com/pages/admin/products/[slug]/edit.vue?macro=true";
import { default as Create2fL3SDCxyGMeta } from "/var/www/tiodomin.com/pages/admin/products/Create.vue?macro=true";
import { default as indexOer879yaVTMeta } from "/var/www/tiodomin.com/pages/admin/products/index.vue?macro=true";
import { default as _91promotor_93timumhzf8CMeta } from "/var/www/tiodomin.com/pages/admin/promotions/commisions/[promotor].vue?macro=true";
import { default as createCGjfKB0TRtMeta } from "/var/www/tiodomin.com/pages/admin/promotions/create.vue?macro=true";
import { default as indexWv29S0K5JtMeta } from "/var/www/tiodomin.com/pages/admin/promotions/index.vue?macro=true";
import { default as promotorsbQNclDx123Meta } from "/var/www/tiodomin.com/pages/admin/promotions/promotors.vue?macro=true";
import { default as showPAY7rTJTyEMeta } from "/var/www/tiodomin.com/pages/admin/promotors/[id]/show.vue?macro=true";
import { default as drawer_request3vgpldSy20Meta } from "/var/www/tiodomin.com/pages/Admin/promotors/drawer_request.vue?macro=true";
import { default as verifyB5hIjUJwl5Meta } from "/var/www/tiodomin.com/pages/admin/promotors/verify.vue?macro=true";
import { default as indexbNhyDV0disMeta } from "/var/www/tiodomin.com/pages/admin/reports/catalog/index.vue?macro=true";
import { default as indexE7RkWzTbeOMeta } from "/var/www/tiodomin.com/pages/admin/reports/inventory/index.vue?macro=true";
import { default as index9cf0vCdDPLMeta } from "/var/www/tiodomin.com/pages/admin/reports/movements/index.vue?macro=true";
import { default as indexFJD9eJKYDNMeta } from "/var/www/tiodomin.com/pages/admin/reports/orders/index.vue?macro=true";
import { default as indexboBkZBs6UVMeta } from "/var/www/tiodomin.com/pages/admin/reports/sale/index.vue?macro=true";
import { default as indexSEvN2mKoJgMeta } from "/var/www/tiodomin.com/pages/admin/reports/salesaccounting/index.vue?macro=true";
import { default as indexi2zjHrBKZLMeta } from "/var/www/tiodomin.com/pages/admin/reports/soldProduct/index.vue?macro=true";
import { default as indexntlx3Ej5BgMeta } from "/var/www/tiodomin.com/pages/admin/reports/unify_sale/index.vue?macro=true";
import { default as indexzovokA0A8jMeta } from "/var/www/tiodomin.com/pages/admin/reviews/index.vue?macro=true";
import { default as _91id_93PFXkazRANYMeta } from "/var/www/tiodomin.com/pages/admin/roles/[id].vue?macro=true";
import { default as CreateIYLGSqXw9sMeta } from "/var/www/tiodomin.com/pages/admin/roles/Create.vue?macro=true";
import { default as indexT8IC0zmNaWMeta } from "/var/www/tiodomin.com/pages/admin/roles/index.vue?macro=true";
import { default as _91id_93exTlnyZ78RMeta } from "/var/www/tiodomin.com/pages/admin/settings/coins/[id].vue?macro=true";
import { default as create6LxXDM17Q7Meta } from "/var/www/tiodomin.com/pages/admin/settings/coins/create.vue?macro=true";
import { default as indexmfyfyhoCUzMeta } from "/var/www/tiodomin.com/pages/admin/settings/coins/index.vue?macro=true";
import { default as CustomizationsOY2e3YB4rMeta } from "/var/www/tiodomin.com/pages/admin/settings/Customization.vue?macro=true";
import { default as create4hcDbfJ0wgMeta } from "/var/www/tiodomin.com/pages/admin/settings/exchangeRates/create.vue?macro=true";
import { default as CreateBatchCMDUGOTa0VMeta } from "/var/www/tiodomin.com/pages/admin/settings/exchangeRates/CreateBatch.vue?macro=true";
import { default as EditZzF0BFY631Meta } from "/var/www/tiodomin.com/pages/admin/settings/exchangeRates/Edit.vue?macro=true";
import { default as indexIluSzKwimsMeta } from "/var/www/tiodomin.com/pages/admin/settings/exchangeRates/index.vue?macro=true";
import { default as GeneralsUXPm5I80QpMeta } from "/var/www/tiodomin.com/pages/admin/settings/Generals.vue?macro=true";
import { default as ContactsFERPzwR02bMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/Contacts.vue?macro=true";
import { default as FrequentAsksUJLYanHsfoMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/FrequentAsks.vue?macro=true";
import { default as InformationSectionVatNuOTcLfMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/InformationSection.vue?macro=true";
import { default as LocalPickupWIpXHh1ASxMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/LocalPickup.vue?macro=true";
import { default as Miscjv79xcX7iIMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/Misc.vue?macro=true";
import { default as MiscellaneousKcW3K5tGkiMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/Miscellaneous.vue?macro=true";
import { default as Notificationsbqdab3k56eMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/Notifications.vue?macro=true";
import { default as PayFormItemG3AOU6f64eMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/PayFormItem.vue?macro=true";
import { default as PayFormsyxCLI5YsGVMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/PayForms.vue?macro=true";
import { default as ProductsInventaryvzE15E1aORMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ProductsInventary.vue?macro=true";
import { default as RelatedProductStrategiesgkeZPjk9r6Meta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/RelatedProductStrategies.vue?macro=true";
import { default as ScheduleFormZW35B6R9k0Meta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ScheduleForm.vue?macro=true";
import { default as ScheduleStoreNTBh4LZgSBMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ScheduleStore.vue?macro=true";
import { default as ShipmentrD6jdNCQ8ZMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/Shipment.vue?macro=true";
import { default as ShipmentProvince3LWrpRuInwMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ShipmentProvince.vue?macro=true";
import { default as ShipmentSelectLocationsVIT3yGQcmjMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ShipmentSelectLocations.vue?macro=true";
import { default as ShipmentUnitRange5jxqMjeVxDMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ShipmentUnitRange.vue?macro=true";
import { default as ShoppingCardCmRQIVugHhMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ShoppingCard.vue?macro=true";
import { default as StorekdhHMNaJKDMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/Store.vue?macro=true";
import { default as TwiceTimeDcML8SQPmzMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/TwiceTime.vue?macro=true";
import { default as _91id_93lILgKz78GEMeta } from "/var/www/tiodomin.com/pages/admin/testimonials/[id].vue?macro=true";
import { default as createxDkpX8YBlCMeta } from "/var/www/tiodomin.com/pages/admin/testimonials/create.vue?macro=true";
import { default as indexvPELYNSKkyMeta } from "/var/www/tiodomin.com/pages/admin/testimonials/index.vue?macro=true";
import { default as _91id_932bmi82t4oZMeta } from "/var/www/tiodomin.com/pages/admin/users/[id].vue?macro=true";
import { default as createAAMUsymMxGMeta } from "/var/www/tiodomin.com/pages/admin/users/create.vue?macro=true";
import { default as indexRxQK0qGytQMeta } from "/var/www/tiodomin.com/pages/admin/users/index.vue?macro=true";
import { default as ConfirmPasswordnGUnMxZOdAMeta } from "/var/www/tiodomin.com/pages/Auth/ConfirmPassword.vue?macro=true";
import { default as ForgotPasswordrhsqQF5IpFMeta } from "/var/www/tiodomin.com/pages/Auth/ForgotPassword.vue?macro=true";
import { default as LoginiL3BFAZLrIMeta } from "/var/www/tiodomin.com/pages/Auth/Login.vue?macro=true";
import { default as RegisterjKHvHfFHSIMeta } from "/var/www/tiodomin.com/pages/Auth/Register.vue?macro=true";
import { default as _91token_93WPGzN43xJlMeta } from "/var/www/tiodomin.com/pages/Auth/ResetPassword/[token].vue?macro=true";
import { default as ResetPasswordYeDDtfrxugMeta } from "/var/www/tiodomin.com/pages/Auth/ResetPassword.vue?macro=true";
import { default as VerifyEmail8DjvYE8Nf6Meta } from "/var/www/tiodomin.com/pages/Auth/VerifyEmail.vue?macro=true";
import { default as _91blog_93lRizQUgQI8Meta } from "/var/www/tiodomin.com/pages/blog/[blog].vue?macro=true";
import { default as indexSNZzxeXd0GMeta } from "/var/www/tiodomin.com/pages/blog/index.vue?macro=true";
import { default as indexG2oWjbWu0sMeta } from "/var/www/tiodomin.com/pages/Cart/index.vue?macro=true";
import { default as _91encoded_939BP5ykw9rGMeta } from "/var/www/tiodomin.com/pages/cart/share-cart/[encoded].vue?macro=true";
import { default as index3TP4pGY4HDMeta } from "/var/www/tiodomin.com/pages/Contact-Us/index.vue?macro=true";
import { default as Indexmlc6FUlBlcMeta } from "/var/www/tiodomin.com/pages/Distribution/Index.vue?macro=true";
import { default as CreatehDZ7W3zVzcMeta } from "/var/www/tiodomin.com/pages/ExchangeRates/Create.vue?macro=true";
import { default as CreateBatchBLR5tzLe6jMeta } from "/var/www/tiodomin.com/pages/ExchangeRates/CreateBatch.vue?macro=true";
import { default as Edit1i59Qy18lfMeta } from "/var/www/tiodomin.com/pages/ExchangeRates/Edit.vue?macro=true";
import { default as IndexcmlnHy3bxcMeta } from "/var/www/tiodomin.com/pages/ExchangeRates/Index.vue?macro=true";
import { default as index5yu5AKGPSOMeta } from "/var/www/tiodomin.com/pages/index.vue?macro=true";
import { default as infolsOpkqDavMMeta } from "/var/www/tiodomin.com/pages/info.vue?macro=true";
import { default as _91InformationPage_93oEsz4xFkVzMeta } from "/var/www/tiodomin.com/pages/information/[InformationPage].vue?macro=true";
import { default as indexeqhMEwA4ptMeta } from "/var/www/tiodomin.com/pages/Offers/index.vue?macro=true";
import { default as redirect_45pagepTdmSebUVcMeta } from "/var/www/tiodomin.com/pages/orders/[order]/redirect-page.vue?macro=true";
import { default as showfU4d9pyNLlMeta } from "/var/www/tiodomin.com/pages/orders/[order]/show.vue?macro=true";
import { default as success_45pageydWvWVRbKDMeta } from "/var/www/tiodomin.com/pages/orders/[order]/success-page.vue?macro=true";
import { default as _91product_93n96UiGRIXCMeta } from "/var/www/tiodomin.com/pages/Products/[product].vue?macro=true";
import { default as editWPWtl5oH7EMeta } from "/var/www/tiodomin.com/pages/Products/[slug]/edit.vue?macro=true";
import { default as Create3M0YeIYOsLMeta } from "/var/www/tiodomin.com/pages/Products/Create.vue?macro=true";
import { default as IndexSd6SV6MhM4Meta } from "/var/www/tiodomin.com/pages/Products/Index.vue?macro=true";
import { default as _91product_931CgC9qU8IwMeta } from "/var/www/tiodomin.com/pages/Products/Review/Read/[product].vue?macro=true";
import { default as _91product_93cT5PFGaBXMMeta } from "/var/www/tiodomin.com/pages/Products/Review/Write/[product].vue?macro=true";
import { default as SuccessPageVziuZQHCfLMeta } from "/var/www/tiodomin.com/pages/Products/SuccessPage.vue?macro=true";
import { default as indexJkZb3s0OL4Meta } from "/var/www/tiodomin.com/pages/Profile/Beneficiaries/index.vue?macro=true";
import { default as indexNjIyaF6sm6Meta } from "/var/www/tiodomin.com/pages/Profile/index.vue?macro=true";
import { default as indexSfuyd4BcAIMeta } from "/var/www/tiodomin.com/pages/Profile/Orders/index.vue?macro=true";
import { default as indexyQVj2xwfiYMeta } from "/var/www/tiodomin.com/pages/Profile/points/index.vue?macro=true";
import { default as analiticsPmA9mU43tXMeta } from "/var/www/tiodomin.com/pages/Profile/promotions/analitics.vue?macro=true";
import { default as createeNJVWNjhcwMeta } from "/var/www/tiodomin.com/pages/Profile/promotions/create.vue?macro=true";
import { default as indexmwUhc44uaoMeta } from "/var/www/tiodomin.com/pages/Profile/promotions/index.vue?macro=true";
import { default as indexy0z9D4BQwYMeta } from "/var/www/tiodomin.com/pages/return-policy/index.vue?macro=true";
import { default as indexH7QoOb4u2IMeta } from "/var/www/tiodomin.com/pages/shipment-policy/index.vue?macro=true";
import { default as indexvVJ3Qi8XYmMeta } from "/var/www/tiodomin.com/pages/store/index.vue?macro=true";
import { default as indexCIsxp9lI6wMeta } from "/var/www/tiodomin.com/pages/terms-conditions/index.vue?macro=true";
import { default as indexWas0By8GAFMeta } from "/var/www/tiodomin.com/pages/warranty-policy/index.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/var/www/tiodomin.com/pages/[...slug].vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/var/www/tiodomin.com/pages/404.vue")
  },
  {
    name: "admin-analytics-Login",
    path: "/admin/analytics/Login",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Login.vue")
  },
  {
    name: "admin-analytics-MostSold",
    path: "/admin/analytics/MostSold",
    meta: MostSoldSOJxJrRY0CMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/MostSold.vue")
  },
  {
    name: "admin-analytics-Partials-Accesses",
    path: "/admin/analytics/Partials/Accesses",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/Accesses.vue")
  },
  {
    name: "admin-analytics-Partials-NewUsers",
    path: "/admin/analytics/Partials/NewUsers",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/NewUsers.vue")
  },
  {
    name: "admin-analytics-Partials-PagesMostVisited",
    path: "/admin/analytics/Partials/PagesMostVisited",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/PagesMostVisited.vue")
  },
  {
    name: "Admin-analytics-Partials-PerfilPromotor",
    path: "/Admin/analytics/Partials/PerfilPromotor",
    component: () => import("/var/www/tiodomin.com/pages/Admin/analytics/Partials/PerfilPromotor.vue")
  },
  {
    name: "admin-analytics-Partials-ProductsAggregatedCart",
    path: "/admin/analytics/Partials/ProductsAggregatedCart",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/ProductsAggregatedCart.vue")
  },
  {
    name: "admin-analytics-Partials-ProductsMostSold",
    path: "/admin/analytics/Partials/ProductsMostSold",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/ProductsMostSold.vue")
  },
  {
    name: "admin-analytics-Partials-ProductsMostVisited",
    path: "/admin/analytics/Partials/ProductsMostVisited",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/ProductsMostVisited.vue")
  },
  {
    name: "admin-analytics-Partials-SalesBehaviour",
    path: "/admin/analytics/Partials/SalesBehaviour",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/SalesBehaviour.vue")
  },
  {
    name: "Admin-analytics-promotors-promotors",
    path: "/Admin/analytics/promotors/:promotors()",
    meta: _91promotors_93BKesol2kFMMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Admin/analytics/promotors/[promotors].vue")
  },
  {
    name: "Admin-analytics-promotors",
    path: "/Admin/analytics/promotors",
    meta: indexAdVNz22uo8Meta || {},
    component: () => import("/var/www/tiodomin.com/pages/Admin/analytics/promotors/index.vue")
  },
  {
    name: "admin-analytics-Sales",
    path: "/admin/analytics/Sales",
    meta: SalesQqgSncrqS2Meta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Sales.vue")
  },
  {
    name: "admin-analytics-Visits",
    path: "/admin/analytics/Visits",
    meta: VisitsBqvrHsNA5jMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Visits.vue")
  },
  {
    name: "admin-banners-id",
    path: "/admin/banners/:id()",
    meta: _91id_93gx3lE7dA4XMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/banners/[id].vue")
  },
  {
    name: "admin-banners-create",
    path: "/admin/banners/create",
    meta: createQxFpATMMsdMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/banners/create.vue")
  },
  {
    name: "admin-banners",
    path: "/admin/banners",
    meta: indexKV3EFdn8yNMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/banners/index.vue")
  },
  {
    name: "admin-blogs-categories-id",
    path: "/admin/blogs/categories/:id()",
    meta: _91id_935rYRsLwjlwMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/categories/[id].vue")
  },
  {
    name: "admin-blogs-categories-create",
    path: "/admin/blogs/categories/create",
    meta: createiJqSURftAQMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/categories/create.vue")
  },
  {
    name: "admin-blogs-categories",
    path: "/admin/blogs/categories",
    meta: indexvoyNkTad06Meta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/categories/index.vue")
  },
  {
    name: "admin-blogs-keywords-id",
    path: "/admin/blogs/keywords/:id()",
    meta: _91id_93iAbGLbmOBDMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/keywords/[id].vue")
  },
  {
    name: "admin-blogs-keywords-create",
    path: "/admin/blogs/keywords/create",
    meta: createkE298lxZ62Meta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/keywords/create.vue")
  },
  {
    name: "admin-blogs-keywords",
    path: "/admin/blogs/keywords",
    meta: indexbt7e7MaSoJMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/keywords/index.vue")
  },
  {
    name: "admin-blogs-posts-id",
    path: "/admin/blogs/posts/:id()",
    meta: _91id_93gAF2CYR8mmMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/posts/[id].vue")
  },
  {
    name: "admin-blogs-posts-create",
    path: "/admin/blogs/posts/create",
    meta: createOJKxfxSopYMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/posts/create.vue")
  },
  {
    name: "admin-blogs-posts",
    path: "/admin/blogs/posts",
    meta: indexAOFrt3bXMGMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/posts/index.vue")
  },
  {
    name: "admin-brands-id",
    path: "/admin/brands/:id()",
    meta: _91id_93xtvOPG9fFRMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/brands/[id].vue")
  },
  {
    name: "admin-brands-create",
    path: "/admin/brands/create",
    meta: createGaDY3rzJZKMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/brands/create.vue")
  },
  {
    name: "admin-brands",
    path: "/admin/brands",
    meta: indexr6JOfKYnNfMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/brands/index.vue")
  },
  {
    name: "admin-categories-id",
    path: "/admin/categories/:id()",
    meta: _91id_93o4A1qtCVCSMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/categories/[id].vue")
  },
  {
    name: "admin-categories-Create",
    path: "/admin/categories/Create",
    meta: CreateVFJscMFJKAMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/categories/Create.vue")
  },
  {
    name: "admin-categories",
    path: "/admin/categories",
    meta: indexYdbe1GxdpqMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/categories/index.vue")
  },
  {
    name: "admin-combos-id",
    path: "/admin/combos/:id()",
    meta: _91id_93njrOj3MHbwMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/combos/[id].vue")
  },
  {
    name: "admin-combos-create",
    path: "/admin/combos/create",
    meta: create8ZdnuHD49UMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/combos/create.vue")
  },
  {
    name: "admin-combos",
    path: "/admin/combos",
    meta: index46xTRu9zKqMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/combos/index.vue")
  },
  {
    name: "admin-criterias",
    path: "/admin/criterias",
    meta: indexpY35mbMUIiMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/criterias/index.vue")
  },
  {
    name: "admin-gift_Cards-id",
    path: "/admin/gift_Cards/:id()",
    meta: _91id_93cHhobzAwjTMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/gift_Cards/[id].vue")
  },
  {
    name: "admin-gift_Cards-create",
    path: "/admin/gift_Cards/create",
    meta: createsHxnayTB3tMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/gift_Cards/create.vue")
  },
  {
    name: "admin-gift_Cards",
    path: "/admin/gift_Cards",
    meta: indexMzokhC73ZeMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/gift_Cards/index.vue")
  },
  {
    name: "admin-invoices-Create",
    path: "/admin/invoices/Create",
    meta: CreateRN6svJP8GTMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/invoices/Create.vue")
  },
  {
    name: "admin-invoices",
    path: "/admin/invoices",
    meta: indexfqGsAIAfNWMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/invoices/index.vue")
  },
  {
    name: "admin-nomenclator",
    path: "/admin/nomenclator",
    meta: indexvBE1GYyZVvMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/nomenclator/index.vue")
  },
  {
    name: "admin-offers-id",
    path: "/admin/offers/:id()",
    meta: _91id_93QIFcBX02OrMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/offers/[id].vue")
  },
  {
    name: "admin-offers-Create",
    path: "/admin/offers/Create",
    meta: Createu4H4Ik0nHCMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/offers/Create.vue")
  },
  {
    name: "admin-offers",
    path: "/admin/offers",
    meta: indexODBGTy8c2zMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/offers/index.vue")
  },
  {
    name: "admin-orders-order-show",
    path: "/admin/orders/:order()/show",
    meta: showfOQQ6Y5S4kMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/orders/[order]/show.vue")
  },
  {
    name: "admin-orders",
    path: "/admin/orders",
    meta: indexAvW1GjazVIMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/orders/index.vue")
  },
  {
    name: "admin-point_of_sales-id",
    path: "/admin/point_of_sales/:id()",
    meta: _91id_93q9kL2I3cgTMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/point_of_sales/[id].vue")
  },
  {
    name: "admin-point_of_sales-create",
    path: "/admin/point_of_sales/create",
    meta: createK3kvH2D6SMMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/point_of_sales/create.vue")
  },
  {
    name: "admin-point_of_sales",
    path: "/admin/point_of_sales",
    meta: index9YrL0mFXSwMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/point_of_sales/index.vue")
  },
  {
    name: "admin-pointsSystem",
    path: "/admin/pointsSystem",
    meta: indexq6eKX6agAEMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/pointsSystem/index.vue")
  },
  {
    name: "Admin-PrintGiftCards",
    path: "/Admin/PrintGiftCards",
    meta: indexwFFBTD1HoSMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Admin/PrintGiftCards/index.vue")
  },
  {
    name: "admin-products-slug-edit",
    path: "/admin/products/:slug()/edit",
    meta: editIcxCZfa66kMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/products/[slug]/edit.vue")
  },
  {
    name: "admin-products-Create",
    path: "/admin/products/Create",
    meta: Create2fL3SDCxyGMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/products/Create.vue")
  },
  {
    name: "admin-products",
    path: "/admin/products",
    meta: indexOer879yaVTMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/products/index.vue")
  },
  {
    name: "admin-promotions-commisions-promotor",
    path: "/admin/promotions/commisions/:promotor()",
    meta: _91promotor_93timumhzf8CMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/promotions/commisions/[promotor].vue")
  },
  {
    name: "admin-promotions-create",
    path: "/admin/promotions/create",
    meta: createCGjfKB0TRtMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/promotions/create.vue")
  },
  {
    name: "admin-promotions",
    path: "/admin/promotions",
    meta: indexWv29S0K5JtMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/promotions/index.vue")
  },
  {
    name: "admin-promotions-promotors",
    path: "/admin/promotions/promotors",
    meta: promotorsbQNclDx123Meta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/promotions/promotors.vue")
  },
  {
    name: "admin-promotors-id-show",
    path: "/admin/promotors/:id()/show",
    meta: showPAY7rTJTyEMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/promotors/[id]/show.vue")
  },
  {
    name: "Admin-promotors-drawer_request",
    path: "/Admin/promotors/drawer_request",
    meta: drawer_request3vgpldSy20Meta || {},
    component: () => import("/var/www/tiodomin.com/pages/Admin/promotors/drawer_request.vue")
  },
  {
    name: "admin-promotors-verify",
    path: "/admin/promotors/verify",
    meta: verifyB5hIjUJwl5Meta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/promotors/verify.vue")
  },
  {
    name: "admin-reports-catalog",
    path: "/admin/reports/catalog",
    meta: indexbNhyDV0disMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/catalog/index.vue")
  },
  {
    name: "admin-reports-inventory",
    path: "/admin/reports/inventory",
    meta: indexE7RkWzTbeOMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/inventory/index.vue")
  },
  {
    name: "admin-reports-movements",
    path: "/admin/reports/movements",
    meta: index9cf0vCdDPLMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/movements/index.vue")
  },
  {
    name: "admin-reports-orders",
    path: "/admin/reports/orders",
    meta: indexFJD9eJKYDNMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/orders/index.vue")
  },
  {
    name: "admin-reports-sale",
    path: "/admin/reports/sale",
    meta: indexboBkZBs6UVMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/sale/index.vue")
  },
  {
    name: "admin-reports-salesaccounting",
    path: "/admin/reports/salesaccounting",
    meta: indexSEvN2mKoJgMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/salesaccounting/index.vue")
  },
  {
    name: "admin-reports-soldProduct",
    path: "/admin/reports/soldProduct",
    meta: indexi2zjHrBKZLMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/soldProduct/index.vue")
  },
  {
    name: "admin-reports-unify_sale",
    path: "/admin/reports/unify_sale",
    meta: indexntlx3Ej5BgMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/unify_sale/index.vue")
  },
  {
    name: "admin-reviews",
    path: "/admin/reviews",
    meta: indexzovokA0A8jMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/reviews/index.vue")
  },
  {
    name: "admin-roles-id",
    path: "/admin/roles/:id()",
    meta: _91id_93PFXkazRANYMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/roles/[id].vue")
  },
  {
    name: "admin-roles-Create",
    path: "/admin/roles/Create",
    meta: CreateIYLGSqXw9sMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/roles/Create.vue")
  },
  {
    name: "admin-roles",
    path: "/admin/roles",
    meta: indexT8IC0zmNaWMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/roles/index.vue")
  },
  {
    name: "admin-settings-coins-id",
    path: "/admin/settings/coins/:id()",
    meta: _91id_93exTlnyZ78RMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/coins/[id].vue")
  },
  {
    name: "admin-settings-coins-create",
    path: "/admin/settings/coins/create",
    meta: create6LxXDM17Q7Meta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/coins/create.vue")
  },
  {
    name: "admin-settings-coins",
    path: "/admin/settings/coins",
    meta: indexmfyfyhoCUzMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/coins/index.vue")
  },
  {
    name: "admin-settings-Customization",
    path: "/admin/settings/Customization",
    meta: CustomizationsOY2e3YB4rMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Customization.vue")
  },
  {
    name: "admin-settings-exchangeRates-create",
    path: "/admin/settings/exchangeRates/create",
    meta: create4hcDbfJ0wgMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/exchangeRates/create.vue")
  },
  {
    name: "admin-settings-exchangeRates-CreateBatch",
    path: "/admin/settings/exchangeRates/CreateBatch",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/exchangeRates/CreateBatch.vue")
  },
  {
    name: "admin-settings-exchangeRates-Edit",
    path: "/admin/settings/exchangeRates/Edit",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/exchangeRates/Edit.vue")
  },
  {
    name: "admin-settings-exchangeRates",
    path: "/admin/settings/exchangeRates",
    meta: indexIluSzKwimsMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/exchangeRates/index.vue")
  },
  {
    name: "admin-settings-Generals",
    path: "/admin/settings/Generals",
    meta: GeneralsUXPm5I80QpMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Generals.vue")
  },
  {
    name: "admin-settings-Partials-Contacts",
    path: "/admin/settings/Partials/Contacts",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/Contacts.vue")
  },
  {
    name: "admin-settings-Partials-FrequentAsks",
    path: "/admin/settings/Partials/FrequentAsks",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/FrequentAsks.vue")
  },
  {
    name: "admin-settings-Partials-InformationSection",
    path: "/admin/settings/Partials/InformationSection",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/InformationSection.vue")
  },
  {
    name: "admin-settings-Partials-LocalPickup",
    path: "/admin/settings/Partials/LocalPickup",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/LocalPickup.vue")
  },
  {
    name: "admin-settings-Partials-Misc",
    path: "/admin/settings/Partials/Misc",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/Misc.vue")
  },
  {
    name: "admin-settings-Partials-Miscellaneous",
    path: "/admin/settings/Partials/Miscellaneous",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/Miscellaneous.vue")
  },
  {
    name: "admin-settings-Partials-Notifications",
    path: "/admin/settings/Partials/Notifications",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/Notifications.vue")
  },
  {
    name: "admin-settings-Partials-PayFormItem",
    path: "/admin/settings/Partials/PayFormItem",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/PayFormItem.vue")
  },
  {
    name: "admin-settings-Partials-PayForms",
    path: "/admin/settings/Partials/PayForms",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/PayForms.vue")
  },
  {
    name: "admin-settings-Partials-ProductsInventary",
    path: "/admin/settings/Partials/ProductsInventary",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ProductsInventary.vue")
  },
  {
    name: "admin-settings-Partials-RelatedProductStrategies",
    path: "/admin/settings/Partials/RelatedProductStrategies",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/RelatedProductStrategies.vue")
  },
  {
    name: "admin-settings-Partials-ScheduleForm",
    path: "/admin/settings/Partials/ScheduleForm",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ScheduleForm.vue")
  },
  {
    name: "admin-settings-Partials-ScheduleStore",
    path: "/admin/settings/Partials/ScheduleStore",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ScheduleStore.vue")
  },
  {
    name: "admin-settings-Partials-Shipment",
    path: "/admin/settings/Partials/Shipment",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/Shipment.vue")
  },
  {
    name: "admin-settings-Partials-ShipmentProvince",
    path: "/admin/settings/Partials/ShipmentProvince",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ShipmentProvince.vue")
  },
  {
    name: "admin-settings-Partials-ShipmentSelectLocations",
    path: "/admin/settings/Partials/ShipmentSelectLocations",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ShipmentSelectLocations.vue")
  },
  {
    name: "admin-settings-Partials-ShipmentUnitRange",
    path: "/admin/settings/Partials/ShipmentUnitRange",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ShipmentUnitRange.vue")
  },
  {
    name: "admin-settings-Partials-ShoppingCard",
    path: "/admin/settings/Partials/ShoppingCard",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ShoppingCard.vue")
  },
  {
    name: "admin-settings-Partials-Store",
    path: "/admin/settings/Partials/Store",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/Store.vue")
  },
  {
    name: "admin-settings-Partials-TwiceTime",
    path: "/admin/settings/Partials/TwiceTime",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/TwiceTime.vue")
  },
  {
    name: "admin-testimonials-id",
    path: "/admin/testimonials/:id()",
    meta: _91id_93lILgKz78GEMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/testimonials/[id].vue")
  },
  {
    name: "admin-testimonials-create",
    path: "/admin/testimonials/create",
    meta: createxDkpX8YBlCMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/testimonials/create.vue")
  },
  {
    name: "admin-testimonials",
    path: "/admin/testimonials",
    meta: indexvPELYNSKkyMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/testimonials/index.vue")
  },
  {
    name: "admin-users-id",
    path: "/admin/users/:id()",
    meta: _91id_932bmi82t4oZMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/users/[id].vue")
  },
  {
    name: "admin-users-create",
    path: "/admin/users/create",
    meta: createAAMUsymMxGMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/users/create.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: indexRxQK0qGytQMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/admin/users/index.vue")
  },
  {
    name: "Auth-ConfirmPassword",
    path: "/Auth/ConfirmPassword",
    component: () => import("/var/www/tiodomin.com/pages/Auth/ConfirmPassword.vue")
  },
  {
    name: "Auth-ForgotPassword",
    path: "/Auth/ForgotPassword",
    component: () => import("/var/www/tiodomin.com/pages/Auth/ForgotPassword.vue")
  },
  {
    name: "Auth-Login",
    path: "/Auth/Login",
    meta: LoginiL3BFAZLrIMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Auth/Login.vue")
  },
  {
    name: "Auth-Register",
    path: "/Auth/Register",
    component: () => import("/var/www/tiodomin.com/pages/Auth/Register.vue")
  },
  {
    name: "Auth-ResetPassword",
    path: "/Auth/ResetPassword",
    meta: ResetPasswordYeDDtfrxugMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Auth/ResetPassword.vue"),
    children: [
  {
    name: "Auth-ResetPassword-token",
    path: ":token()",
    component: () => import("/var/www/tiodomin.com/pages/Auth/ResetPassword/[token].vue")
  }
]
  },
  {
    name: "Auth-VerifyEmail",
    path: "/Auth/VerifyEmail",
    component: () => import("/var/www/tiodomin.com/pages/Auth/VerifyEmail.vue")
  },
  {
    name: "blog-blog",
    path: "/blog/:blog()",
    component: () => import("/var/www/tiodomin.com/pages/blog/[blog].vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/var/www/tiodomin.com/pages/blog/index.vue")
  },
  {
    name: "Cart",
    path: "/Cart",
    component: () => import("/var/www/tiodomin.com/pages/Cart/index.vue")
  },
  {
    name: "cart-share-cart-encoded",
    path: "/cart/share-cart/:encoded()",
    component: () => import("/var/www/tiodomin.com/pages/cart/share-cart/[encoded].vue")
  },
  {
    name: "Contact-Us",
    path: "/Contact-Us",
    component: () => import("/var/www/tiodomin.com/pages/Contact-Us/index.vue")
  },
  {
    name: "Distribution-Index",
    path: "/Distribution/Index",
    component: () => import("/var/www/tiodomin.com/pages/Distribution/Index.vue")
  },
  {
    name: "ExchangeRates-Create",
    path: "/ExchangeRates/Create",
    component: () => import("/var/www/tiodomin.com/pages/ExchangeRates/Create.vue")
  },
  {
    name: "ExchangeRates-CreateBatch",
    path: "/ExchangeRates/CreateBatch",
    component: () => import("/var/www/tiodomin.com/pages/ExchangeRates/CreateBatch.vue")
  },
  {
    name: "ExchangeRates-Edit",
    path: "/ExchangeRates/Edit",
    component: () => import("/var/www/tiodomin.com/pages/ExchangeRates/Edit.vue")
  },
  {
    name: "ExchangeRates-Index",
    path: "/ExchangeRates/Index",
    component: () => import("/var/www/tiodomin.com/pages/ExchangeRates/Index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index5yu5AKGPSOMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/index.vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/var/www/tiodomin.com/pages/info.vue")
  },
  {
    name: "information-InformationPage",
    path: "/information/:InformationPage()",
    component: () => import("/var/www/tiodomin.com/pages/information/[InformationPage].vue")
  },
  {
    name: "Offers",
    path: "/Offers",
    meta: indexeqhMEwA4ptMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Offers/index.vue")
  },
  {
    name: "orders-order-redirect-page",
    path: "/orders/:order()/redirect-page",
    meta: redirect_45pagepTdmSebUVcMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/orders/[order]/redirect-page.vue")
  },
  {
    name: "orders-order-show",
    path: "/orders/:order()/show",
    meta: showfU4d9pyNLlMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/orders/[order]/show.vue")
  },
  {
    name: "orders-order-success-page",
    path: "/orders/:order()/success-page",
    component: () => import("/var/www/tiodomin.com/pages/orders/[order]/success-page.vue")
  },
  {
    name: "Products-product",
    path: "/Products/:product()",
    meta: _91product_93n96UiGRIXCMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Products/[product].vue")
  },
  {
    name: "Products-slug-edit",
    path: "/Products/:slug()/edit",
    component: () => import("/var/www/tiodomin.com/pages/Products/[slug]/edit.vue")
  },
  {
    name: "Products-Create",
    path: "/Products/Create",
    meta: Create3M0YeIYOsLMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Products/Create.vue")
  },
  {
    name: "Products-Index",
    path: "/Products/Index",
    meta: IndexSd6SV6MhM4Meta || {},
    component: () => import("/var/www/tiodomin.com/pages/Products/Index.vue")
  },
  {
    name: "Products-Review-Read-product",
    path: "/Products/Review/Read/:product()",
    component: () => import("/var/www/tiodomin.com/pages/Products/Review/Read/[product].vue")
  },
  {
    name: "Products-Review-Write-product",
    path: "/Products/Review/Write/:product()",
    component: () => import("/var/www/tiodomin.com/pages/Products/Review/Write/[product].vue")
  },
  {
    name: "Products-SuccessPage",
    path: "/Products/SuccessPage",
    component: () => import("/var/www/tiodomin.com/pages/Products/SuccessPage.vue")
  },
  {
    name: "Profile-Beneficiaries",
    path: "/Profile/Beneficiaries",
    meta: indexJkZb3s0OL4Meta || {},
    component: () => import("/var/www/tiodomin.com/pages/Profile/Beneficiaries/index.vue")
  },
  {
    name: "Profile",
    path: "/Profile",
    meta: indexNjIyaF6sm6Meta || {},
    component: () => import("/var/www/tiodomin.com/pages/Profile/index.vue")
  },
  {
    name: "Profile-Orders",
    path: "/Profile/Orders",
    meta: indexSfuyd4BcAIMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Profile/Orders/index.vue")
  },
  {
    name: "Profile-points",
    path: "/Profile/points",
    meta: indexyQVj2xwfiYMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Profile/points/index.vue")
  },
  {
    name: "Profile-promotions-analitics",
    path: "/Profile/promotions/analitics",
    meta: analiticsPmA9mU43tXMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Profile/promotions/analitics.vue")
  },
  {
    name: "Profile-promotions-create",
    path: "/Profile/promotions/create",
    meta: createeNJVWNjhcwMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Profile/promotions/create.vue")
  },
  {
    name: "Profile-promotions",
    path: "/Profile/promotions",
    meta: indexmwUhc44uaoMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Profile/promotions/index.vue")
  },
  {
    name: "return-policy",
    path: "/return-policy",
    component: () => import("/var/www/tiodomin.com/pages/return-policy/index.vue")
  },
  {
    name: "shipment-policy",
    path: "/shipment-policy",
    component: () => import("/var/www/tiodomin.com/pages/shipment-policy/index.vue")
  },
  {
    name: "store",
    path: "/store",
    meta: indexvVJ3Qi8XYmMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/store/index.vue")
  },
  {
    name: "terms-conditions",
    path: "/terms-conditions",
    component: () => import("/var/www/tiodomin.com/pages/terms-conditions/index.vue")
  },
  {
    name: "warranty-policy",
    path: "/warranty-policy",
    component: () => import("/var/www/tiodomin.com/pages/warranty-policy/index.vue")
  }
]